import { render } from "./TaskFormViewer.vue?vue&type=template&id=3a527b25&scoped=true&ts=true"
import script from "./TaskFormViewer.vue?vue&type=script&lang=ts"
export * from "./TaskFormViewer.vue?vue&type=script&lang=ts"

import "./TaskFormViewer.vue?vue&type=style&index=0&id=3a527b25&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a527b25"]])

export default __exports__